import { RouteLegWageBase } from '../shared/route-leg-wage-base';
import { Route } from './route';

export class RouteLegWage extends RouteLegWageBase {
  routeID: string;
  route: Route;

  constructor(jsonData?: Partial<RouteLegWage>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.route) this.route = new Route(jsonData.route);
    }
  }
}
